export const KAIZEN_TRANSLATIONS = {
  tr: {
    languageName: "Türkçe",
    headerTitle: "Çalışan Öneri Formu",
    noLogin: "Giriş gerekmez",
    eyebrow: "Önerini bize yaz",
    heroTitle: "İşini kolaylaştıracak bir fikrin var mı?",
    heroText: "Sorunu ve çözümünü yaz. Form yalnızca 2 adımdan oluşur.",
    step: (value) => `Adım ${value} / 2`,
    stepOneText: "Önce sizi tanıyalım",
    stepTwoText: "Şimdi önerinizi anlatın",
    personalTitle: "Sizin bilgileriniz",
    suggestionTitle: "Öneriniz",
    requiredHint: "Yıldızlı alanların doldurulması gerekir.",
    simpleHint: "Kısa ve anlaşılır yazmanız yeterlidir.",
    missingTitle: "Eksik bilgi var",
    missingText: "Kırmızı gösterilen alanı doldurun.",
    firstName: "Adınız",
    firstNamePlaceholder: "Örnek: Ahmet",
    lastName: "Soyadınız",
    lastNamePlaceholder: "Örnek: Yılmaz",
    employeeNo: "Sicil numaranız",
    employeeNoPlaceholder: "Sicil numaranızı yazın",
    employeeNoHelp: "Personel kartınızda yazan numara.",
    department: "Çalıştığınız bölüm",
    departmentPlaceholder: "Bölüm seçin",
    shift: "Vardiyanız",
    shiftPlaceholder: "Vardiya seçin",
    teamLeader: "Takım liderinizin adı",
    teamLeaderPlaceholder: "Adını ve soyadını yazın",
    continueButton: "Önerimi yazmaya geç",
    subject: "Önerinizin kısa adı",
    subjectPlaceholder: "Örnek: Malzeme arabasının yerini değiştirme",
    classification: "Öneriniz en çok neyi iyileştiriyor?",
    classificationPlaceholder: "Konu seçin",
    currentSituation: "Şu anda sorun nedir?",
    currentSituationHelp: "Örnek: Malzemeyi almak için her seferinde 10 metre yürüyoruz.",
    currentSituationPlaceholder: "Sorunu kendi cümlelerinizle yazın",
    proposedSolution: "Sizce ne yapılmalı?",
    proposedSolutionHelp: "Örnek: Malzeme arabası tezgâhın yanına alınabilir.",
    proposedSolutionPlaceholder: "Çözüm önerinizi yazın",
    optionalTitle: "Varsa ek bilgi ver",
    optionalText: "Bu bölümü boş bırakabilirsiniz.",
    impactFrequency: "Fayda ne kadar sürer?",
    implementationStatus: "Öneri uygulandı mı?",
    notImplemented: "Henüz uygulanmadı",
    implemented: "Uygulandı",
    investment: "Gerekli maliyet veya zaman",
    investmentPlaceholder: "Biliyorsanız yazın",
    expectedBenefit: "Beklenen fayda",
    expectedBenefitPlaceholder: "Zaman, maliyet, güvenlik vb.",
    targetDate: "Uygulama tarihi",
    responsiblePerson: "Uygulayacak kişi",
    responsiblePlaceholder: "Biliyorsanız yazın",
    backButton: "Geri dön",
    submitButton: "Önerimi gönder",
    submitting: "Kaydediliyor",
    privacy: "Bilgileriniz yalnızca önerinizin değerlendirilmesi için kullanılır.",
    successEyebrow: "İşlem tamamlandı",
    successTitle: "Öneriniz kaydedildi",
    successText: "Aşağıdaki numarayı saklayın. İsterseniz ekran görüntüsü alabilirsiniz.",
    successMessage: "Teşekkür ederiz. Öneriniz yetkili kişiler tarafından incelenecek.",
    newSuggestion: "Başka bir öneri yaz",
    requestError: "Öneriniz kaydedilemedi. İnternet bağlantınızı kontrol edip tekrar deneyin.",
    errors: {
      firstName: "Adınızı yazın.",
      lastName: "Soyadınızı yazın.",
      department: "Çalıştığınız bölümü seçin.",
      shift: "Vardiyanızı seçin.",
      employeeNo: "Sicil numaranızı yazın.",
      teamLeader: "Takım liderinizin adını yazın.",
      subject: "Önerinize kısa bir ad verin.",
      classification: "Önerinizin konusunu seçin.",
      currentSituation: "Şu anki sorunu anlatın.",
      proposedSolution: "Sizce ne yapılması gerektiğini anlatın.",
    },
    classifications: {
      is_guvenligi_ergonomi: "İş güvenliği veya ergonomi",
      kalite: "Kalite",
      maliyet: "Maliyet düşürme",
      verimlilik_zaman: "İşi kolaylaştırma veya hızlandırma",
      cevre: "Çevre",
      diger: "Diğer",
    },
    impactOptions: {
      "": "Seçiniz",
      parca_basi: "Parça başı",
      senelik: "Senelik",
      bir_sefer: "Bir sefer",
    },
    departments: {
      Üretim: "Üretim",
      Kalite: "Kalite",
      Bakım: "Bakım",
      Sevkiyat: "Sevkiyat",
      Depo: "Depo",
      Planlama: "Planlama",
      "İdari İşler": "İdari İşler",
      "Satın Alma": "Satın Alma",
      Satış: "Satış",
      "İnsan Kaynakları": "İnsan Kaynakları",
      Muhasebe: "Muhasebe",
      "Dış Ticaret": "Dış Ticaret",
      Diğer: "Diğer",
    },
    shifts: {
      Gündüz: "Gündüz",
      "08:00 - 16:00": "08:00 - 16:00",
      "16:00 - 00:00": "16:00 - 00:00",
      "00:00 - 08:00": "00:00 - 08:00",
      Diğer: "Diğer",
    },
  },
  tk: {
    languageName: "Türkmençe",
    headerTitle: "Işgär teklip formasy",
    noLogin: "Giriş gerek däl",
    eyebrow: "Teklibiňizi bize ýazyň",
    heroTitle: "Işiňizi aňsatlaşdyrjak pikiriňiz barmy?",
    heroText: "Meseläni we çözgüdiňizi ýazyň. Forma bary-ýogy 2 ädimden ybarat.",
    step: (value) => `Ädim ${value} / 2`,
    stepOneText: "Ilki sizi tanalyň",
    stepTwoText: "Indi teklibiňizi beýan ediň",
    personalTitle: "Siziň maglumatlaryňyz",
    suggestionTitle: "Teklibiňiz",
    requiredHint: "Ýyldyz (*) belgili ýerleri doldurmak hökmany.",
    simpleHint: "Gysga we düşnükli ýazsaňyz ýeterlik.",
    missingTitle: "Maglumat ýetmeýär",
    missingText: "Gyzyl görkezilen ýeri dolduryň.",
    firstName: "Adyňyz",
    firstNamePlaceholder: "Mysal: Murat",
    lastName: "Familiýaňyz",
    lastNamePlaceholder: "Mysal: Orazow",
    employeeNo: "Işgär belgiňiz",
    employeeNoPlaceholder: "Işgär belgiňizi ýazyň",
    employeeNoHelp: "Işgär kartyňyzda ýazylan belgi.",
    department: "Işleýän bölümiňiz",
    departmentPlaceholder: "Bölümi saýlaň",
    shift: "Çalşygyňyz",
    shiftPlaceholder: "Çalşygy saýlaň",
    teamLeader: "Topar ýolbaşçyňyzyň ady",
    teamLeaderPlaceholder: "Adyny we familiýasyny ýazyň",
    continueButton: "Teklibimi ýazmaga geç",
    subject: "Teklibiňiziň gysga ady",
    subjectPlaceholder: "Mysal: Material arabasynyň ýerini üýtgetmek",
    classification: "Teklibiňiz esasan nämäni gowulandyrýar?",
    classificationPlaceholder: "Temany saýlaň",
    currentSituation: "Häzirki mesele näme?",
    currentSituationHelp: "Mysal: Materialy almak üçin her gezek 10 metr ýöreýäris.",
    currentSituationPlaceholder: "Meseläni öz sözleriňiz bilen ýazyň",
    proposedSolution: "Siziň pikiriňizçe näme edilmeli?",
    proposedSolutionHelp: "Mysal: Material arabasyny stanogyň ýanyna goýup bolýar.",
    proposedSolutionPlaceholder: "Çözgüt teklibiňizi ýazyň",
    optionalTitle: "Bar bolsa goşmaça maglumat beriň",
    optionalText: "Bu bölümi boş goýup bilersiňiz.",
    impactFrequency: "Peýda näçe wagt dowam eder?",
    implementationStatus: "Teklip amala aşyryldymy?",
    notImplemented: "Entäk amala aşyrylmady",
    implemented: "Amala aşyryldy",
    investment: "Gerekli çykdajy ýa-da wagt",
    investmentPlaceholder: "Bilýän bolsaňyz ýazyň",
    expectedBenefit: "Garaşylýan peýda",
    expectedBenefitPlaceholder: "Wagt, çykdajy, howpsuzlyk we ş.m.",
    targetDate: "Amala aşyryljak senesi",
    responsiblePerson: "Amala aşyrjak işgär",
    responsiblePlaceholder: "Bilýän bolsaňyz ýazyň",
    backButton: "Yza",
    submitButton: "Teklibimi iber",
    submitting: "Ýazga alynýar",
    privacy: "Maglumatlaryňyz diňe teklibiňize baha bermek üçin ulanylýar.",
    successEyebrow: "Tamamlandy",
    successTitle: "Teklibiňiz ýazga alyndy",
    successText: "Aşakdaky belgini saklaň. Isleseňiz ekran suratyny alyp bilersiňiz.",
    successMessage: "Sag boluň. Teklibiňize jogapkär işgärler serederler.",
    newSuggestion: "Başga teklip ýaz",
    requestError: "Teklibiňiz ýazga alnyp bilinmedi. Internet birikmesini barlap, gaýtadan synanyşyň.",
    errors: {
      firstName: "Adyňyzy ýazyň.",
      lastName: "Familiýaňyzy ýazyň.",
      department: "Işleýän bölümiňizi saýlaň.",
      shift: "Çalşygyňyzy saýlaň.",
      employeeNo: "Işgär belgiňizi ýazyň.",
      teamLeader: "Topar ýolbaşçyňyzyň adyny ýazyň.",
      subject: "Teklibiňize gysga at beriň.",
      classification: "Teklibiňiziň temasyny saýlaň.",
      currentSituation: "Häzirki meseläni düşündiriň.",
      proposedSolution: "Näme edilmelidigini düşündiriň.",
    },
    classifications: {
      is_guvenligi_ergonomi: "Iş howpsuzlygy ýa-da ergonomika",
      kalite: "Hil",
      maliyet: "Çykdajylary azaltmak",
      verimlilik_zaman: "Işi aňsatlaşdyrmak ýa-da çaltlandyrmak",
      cevre: "Daşky gurşaw",
      diger: "Başga",
    },
    impactOptions: {
      "": "Saýlaň",
      parca_basi: "Her bölek üçin",
      senelik: "Ýyllyk",
      bir_sefer: "Bir gezek",
    },
    departments: {
      Üretim: "Önümçilik",
      Kalite: "Hil",
      Bakım: "Tehniki hyzmat",
      Sevkiyat: "Ugratma",
      Depo: "Ammar",
      Planlama: "Meýilleşdiriş",
      "İdari İşler": "Administratiw işler",
      "Satın Alma": "Satyn alyş",
      Satış: "Satuw",
      "İnsan Kaynakları": "Adam serişdeleri",
      Muhasebe: "Hasaphana",
      "Dış Ticaret": "Daşary söwda",
      Diğer: "Başga",
    },
    shifts: {
      Gündüz: "Gündizki",
      "08:00 - 16:00": "08:00 - 16:00",
      "16:00 - 00:00": "16:00 - 00:00",
      "00:00 - 08:00": "00:00 - 08:00",
      Diğer: "Başga",
    },
  },
};
